export const HeaderConstants = {
	PRIMARY_HEADER_HEIGHT: 60,
	SECONDARY_HEADER_HEIGHT: 70,
	IMPERSONATE_HEADER_HEIGHT: 48
};
